import { SegmentMapping } from "../store/reducers/revenueReducer"

export const getSegment = (revenue: number, segmentConfig: SegmentMapping[]) =>
    segmentConfig.find((s) => revenue > s.averageRevenueMoreThan)?.segment ?? "Unknown"
